// extracted by mini-css-extract-plugin
export default {"iframe":"payment_iframe__9WeiH"};